import { Controller } from '@hotwired/stimulus'
import { handleProductSelectionResponse } from '../selection/response-handler'

/**
 * Handles heatshrink kit product link clicks
 * Uses fetch API to POST and handle JSON responses with HTML fragments
 * Replaces Rails UJS `remote: true, method: :post` pattern
 */
export default class extends Controller {
  static values = {
    url: String
  }

  click(event) {
    event.preventDefault()

    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'X-CSRF-Token': this.csrfToken
      },
      credentials: 'same-origin'
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.json()
      })
      .then(data => {
        handleProductSelectionResponse(data)
      })
      .catch(error => {
        console.error('Heatshrink kit product selection failed:', error)
      })
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ''
  }
}
